import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  userGet,
  addAttributeUserValue,
  userUpdate,
  updateAdress,
  updateIdentity,
  createContact,
  personGet,
  deleteUser,
} from './_api';
import { get, compact, find, isObject } from 'lodash';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Grid as Grid2, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import PersonForm from './detail/personForm';
import EditUserForm from './detail/userForm';
import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import {
  reservationStatusNames,
  printPdfDocument,
  allReservationsForUser,
  archivedReservationsForUser,
} from '../reservations/_api';

import { DataTypeProvider } from '@devexpress/dx-react-grid';

const styles = (theme) => ({
  root: {
    margin: 10,
  },
  paper: {
    padding: theme.spacing.unit,
    marginBottom: 20,
  },
});

const DateFormatter = ({ value }) => moment(value).format('DD.MM.YYYY, HH:mm:ss');

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
);

const enhance = compose(
  withSnackbar,
  withStyles(styles),
  withLoader,
  withRouter,
  withState('addPerson', 'setAddPerson', false),
  withState('editPerson', 'setEditPerson', false),
  withState('contact', 'setContact', null),
  withState('edit', 'setEdit', false),
  withState('statusNames', 'setStatusNames', []),
  withState('items', 'setItems', []),
  connect(
    (state) => ({
      user: get(state, 'app.userData', null),
      userAttributes: get(state, 'app.userAttributes', []),
    }),
    { userGet }
  ),
  withHandlers({
    redirectTo:
      ({ history }) =>
      (id, archived = false) => {
        history.push(`/reservations/${id}?archived=${archived}`);
      },
  }),
  withHandlers({
    TableRow:
      ({ redirectTo }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
              ':hover': { background: '#7eb6e4' },
            }}
            onClick={() => redirectTo(get(row, 'id'), get(row, 'archived', false))}
          />
        ),
  }),
  withProps(
    ({
      match: {
        params: { id },
      },
      user,
      setContact,
      setEditPerson,
      setDialog,
      statusNames,
      toggleLoader,
      enqueueSnackbar,
    }) => {
      let initialAttributes = [];
      get(user, 'attributes', []).forEach((item) => {
        initialAttributes[item.attributeId] =
          item.name === 'Výška' ? { label: item.value, value: item.id } : item.id;
      });
      return {
        userId: id,
        initialAttributes,
        columns: [
          {
            name: 'name',
            title: 'Jméno',
            getCellValue: (row) =>
              row ? `${get(row, 'contact.surname', '')} ${get(row, 'contact.forename', '')}` : '',
          },
          {
            name: 'delete',
            title: ' ',
            getCellValue: (row) => (
              <div>
                <Button
                  variant="outlined"
                  onClick={async (e) => {
                    const resp = await personGet(row.contactId);
                    setContact(resp);
                    setEditPerson(true);
                  }}
                  style={{ marginRight: 5 }}
                >
                  Upravit
                </Button>
                <Button
                  variant="outlined"
                  onClick={(e) => {
                    setDialog({ open: true, id: row.contactId, action: 'user-delete' });
                  }}
                >
                  Smazat
                </Button>
              </div>
            ),
          },
        ],
        columnsReservation: [
          { name: 'id', title: 'id' },
          {
            name: 'user',
            title: 'Uživatel',
            getCellValue: (row) =>
              `${get(row, 'user.surname', '')} ${get(row, 'user.forename', '')}`,
          },
          {
            name: 'status',
            title: 'Status',
            getCellValue: (row) =>
              get(find(statusNames, { flagValue: get(row, 'status') }), 'name'),
          },
          { name: 'from', title: 'Od' },
          { name: 'to', title: 'Do' },
          { name: 'note', title: 'Poznámka' },
          { name: 'createdDate', title: 'Vytvořeno' },
          {
            name: 'print',
            title: 'Tisk',
            getCellValue: (row) => (
              <div style={{ display: 'flex' }}>
                <div>
                  <Button
                    variant="outlined"
                    onClick={async (e) => {
                      e.stopPropagation();
                      toggleLoader();
                      const data = await printPdfDocument(row.id, 'reservation');
                      const dataB64 = get(data, 'data');
                      if (dataB64) {
                        const linkSource = `data:application/pdf;base64,${dataB64}`;
                        var a = document.createElement('a');
                        a.href = linkSource;
                        a.download = `R-${get(row, 'user.surname', '')}-${get(
                          row,
                          'id',
                          ''
                        )}-${moment(get(row, 'from')).format('YYMMDD')}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                      } else {
                        enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                          variant: 'error',
                        });
                      }
                      toggleLoader(false);
                    }}
                  >
                    R
                  </Button>
                </div>
                <div>
                  <Button
                    variant="outlined"
                    onClick={async (e) => {
                      e.stopPropagation();
                      toggleLoader();
                      const data = await printPdfDocument(row.id, 'contract');
                      const dataB64 = get(data, 'data');
                      if (dataB64) {
                        const linkSource = `data:application/pdf;base64,${dataB64}`;
                        var a = document.createElement('a');
                        a.href = linkSource;
                        a.download = `S-${get(row, 'user.surname', '')}-${get(
                          row,
                          'id',
                          ''
                        )}-${moment(get(row, 'from')).format('YYMMDD')}.pdf`;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                      } else {
                        enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                          variant: 'error',
                        });
                      }
                      toggleLoader(false);
                    }}
                  >
                    S
                  </Button>
                </div>
              </div>
            ),
          },
        ],
      };
    }
  ),
  lifecycle({
    async componentDidMount() {
      const { userId, userGet, toggleLoader, setItems, setStatusNames } = this.props;
      toggleLoader();
      await userGet(userId);
      const [reservations, archivedReservations, statusNames] = await Promise.all([
        allReservationsForUser(parseInt(userId, 10)),
        archivedReservationsForUser(parseInt(userId, 10)),
        reservationStatusNames(),
      ]);
      if (reservations || archivedReservations) {
        setItems([
          ...get(reservations, 'items', []),
          ...get(archivedReservations, 'items', []).map((item) => ({ ...item, archived: true })),
        ]);
      }
      if (statusNames) {
        setStatusNames(statusNames);
      }
      toggleLoader(false);
    },
    async componentWillReceiveProps(nextProps) {
      const { toggleLoader, userId, reload, userGet } = this.props;
      if (reload !== nextProps.reload) {
        toggleLoader();
        await userGet(userId);
        toggleLoader(false);
      }
    },
  }),
  withHandlers({
    handleChange:
      ({ setExpanded, expanded }) =>
      (panel, expand) => {
        setExpanded({ ...expanded, [panel]: expand });
      },
    onSubmitPerson:
      ({
        toggleLoader,
        userGet,
        setAddPerson,
        setEditPerson,
        setContact,
        addPerson,
        enqueueSnackbar,
        contact,
        userId,
      }) =>
      async (values) => {
        const contactId = get(contact, 'id');
        toggleLoader();
        const attributes = compact(get(values, 'userAttributeValues', [])).map((attr) => {
          let attribute = attr;
          if (isObject(attr)) {
            attribute = get(attr, 'value', null);
          }
          return attribute;
        });
        if (addPerson) {
          const resp = await createContact(parseInt(userId, 10), {
            newForename: values.forename,
            newSurname: values.surname,
            newUserAttributeValues: attributes,
          });
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Osoba byla úspěšně vytvořena.', { variant: 'success' });
          } else {
            enqueueSnackbar('Osobu se nepodařilo vytvořit.', { variant: 'error' });
          }
        } else {
          const respUser = await userUpdate(parseInt(contactId, 10), {
            forename: get(values, 'forename', ''),
            surname: get(values, 'surname', ''),
          });
          const respAtt = await addAttributeUserValue(contactId, attributes);
          if (get(respUser, 'success', false) && get(respAtt, 'success', false)) {
            enqueueSnackbar('Osoba byla úspěšně upravena.', { variant: 'success' });
          } else {
            enqueueSnackbar('Osoba se nepodařila upravit.', { variant: 'error' });
          }
        }

        await userGet(userId);
        toggleLoader(false);
        setAddPerson(false);
        setEditPerson(false);
        setContact(null);
      },
    onSubmitEditUser:
      ({ userId, setEdit, userGet, toggleLoader, enqueueSnackbar, setEditPerson }) =>
      async (values) => {
        toggleLoader();
        const respInfo = await userUpdate(userId, {
          ...values.userInfo,
          birthDate: get(values, 'userInfo.birthDate', null) ? values.userInfo.birthDate : null,
        });
        const attributes = compact(get(values, 'attributes', [])).map((attr) => {
          let attribute = attr;
          if (isObject(attr)) {
            attribute = get(attr, 'value', null);
          }
          return attribute;
        });
        const respAttr = await addAttributeUserValue(userId, attributes);
        const respAddr = await updateAdress(values.address);
        const respIdent = await updateIdentity(userId, {
          ...values.identity,
          expiration: get(values, 'identity.expiration', null) ? values.identity.expiration : null,
        });

        if (
          get(respInfo, 'success', false) &&
          get(respAttr, 'success', false) &&
          get(respAddr, 'success', false) &&
          get(respIdent, 'success', false)
        ) {
          enqueueSnackbar('Data o uživateli byla úspěšně uložena.', { variant: 'success' });
        } else {
          enqueueSnackbar('Data o uživateli se nepodařila uložit.', { variant: 'error' });
        }

        setEdit(false);
        await userGet(userId);
        toggleLoader(false);
      },
    formUserAttributesValues: () => (attributtes) => {
      let initialAttributes = [];
      attributtes.map((item) => {
        initialAttributes[item.attributeId] =
          item.name === 'Výška' ? { label: item.value, value: item.id } : item.id;
        return '';
      });
      return initialAttributes;
    },
    deleteUser:
      ({ dialog, toggleLoader, setItems, setDialog, userGet, userId }) =>
      async () => {
        const id = get(dialog, 'id', false);
        toggleLoader();
        if (id) {
          await deleteUser(id);
          await userGet(userId);
          setDialog({ open: false, id: null });
          toggleLoader(false);
        }
      },
  })
);

export default enhance(
  ({
    classes,
    user,
    expanded,
    handleChange,
    userAttributes,
    TableRow,
    addPerson,
    setAddPerson,
    onSubmitPerson,
    edit,
    setEdit,
    onSubmitEditUser,
    initialAttributes,
    columns,
    editPerson,
    contact,
    setContact,
    setEditPerson,
    formUserAttributesValues,
    dialog,
    setDialog,
    deleteUser,
    history,
    items,
    columnsReservation,
  }) => (
    <div className={classes.root}>
      <h2>{`${get(user, 'surname', '')} ${get(user, 'forename', '')}`}</h2>
      <div style={{ paddingBottom: 20 }}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => {
            history.push(`/reservations?user=${user.id}`);
          }}
        >
          Přidat rezervaci
        </Button>
      </div>
      <Paper className={classes.paper}>
        {!edit && (
          <React.Fragment>
            <Grid container spacing={8} style={{ paddingBottom: 20 }}>
              <Grid item xs={3}>
                <b>Jméno</b>
                <br />
                {`${get(user, 'surname', '')} ${get(user, 'forename', '')} `}
              </Grid>
              <Grid item xs={3}>
                <b>Email</b>
                <br />
                {get(user, 'email', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Telefon</b>
                <br />
                {get(user, 'phone', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Datum narození</b>
                <br />
                {get(user, 'birthDate', false)
                  ? moment(get(user, 'birthDate', '')).format('DD.MM.YYYY')
                  : ''}
              </Grid>
              {userAttributes.map((item) => {
                const attValue = find(get(user, 'attributes', []), { attributeId: item.id });
                return (
                  <Grid key={item.id} item xs={3}>
                    <b>{`${get(item, 'name', '')}`}</b>
                    <br />
                    {attValue ? `${get(attValue, 'value', '')} ` : ''}
                    {get(attValue, 'unit', '') === '' ? '' : get(attValue, 'unit', '')}
                  </Grid>
                );
              })}
            </Grid>
            <Grid container spacing={8} style={{ paddingBottom: 20 }}>
              <Grid item xs={3}>
                <b>Ulice</b>
                <br />
                {`${get(user, 'address.street', '')} ${get(user, 'address.streetNumber', '')}`}
              </Grid>
              <Grid item xs={3}>
                <b>Město</b>
                <br /> {get(user, 'address.city', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Směrovací číslo</b> <br /> {get(user, 'address.postalCode', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Popis</b>
                <br /> {get(user, 'address.description', '')}
              </Grid>
            </Grid>
            <Grid container spacing={8} style={{ paddingBottom: 10 }}>
              <Grid item xs={3}>
                <b>Rodné číslo</b>
                <br /> {get(user, 'identity.userIdNumber', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Typ průkazu</b>
                <br /> {get(user, 'identity.typeId', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Číslo průkazu</b>
                <br /> {get(user, 'identity.serialNumber', '')}
              </Grid>
              <Grid item xs={3}>
                <b>Expirace</b>
                <br />
                {get(user, 'identity.expiration', false)
                  ? moment(get(user, 'identity.expiration', '')).format('DD.MM.YYYY')
                  : ''}
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => setEdit(true)}
            >
              Upravit
            </Button>
          </React.Fragment>
        )}
        {edit && (
          <EditUserForm
            onSubmit={onSubmitEditUser}
            initialValues={{
              userInfo: {
                forename: get(user, 'forename', null),
                surname: get(user, 'surname', null),
                email: get(user, 'email', undefined),
                personId: get(user, 'id', undefined),
                phone: get(user, 'phone', null),
                birthDate: get(user, 'birthDate', false)
                  ? moment(get(user, 'birthDate', null)).format('YYYY-MM-DD')
                  : undefined,
              },
              attributes: initialAttributes,
              address: get(user, 'address', {}),
              identity: {
                ...get(user, 'identity', {}),
                expiration: get(user, 'identity.expiration', false)
                  ? moment(get(user, 'identity.expiration', '')).format('YYYY-MM-DD')
                  : undefined,
              },
            }}
            setEdit={setEdit}
          />
        )}
      </Paper>
      <Paper className={classes.paper}>
        <h2>Osoby</h2>
        {!addPerson && !editPerson && (
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => setAddPerson(true)}
          >
            Přidat
          </Button>
        )}
        <div>
          {(addPerson || (editPerson && contact)) && (
            <PersonForm
              setAddPerson={setAddPerson}
              setEditPerson={setEditPerson}
              setContact={setContact}
              onSubmit={onSubmitPerson}
              initialValues={
                editPerson
                  ? {
                      forename: get(contact, 'forename', ''),
                      surname: get(contact, 'surname', ''),
                      userAttributeValues: formUserAttributesValues(get(contact, 'attributes', [])),
                    }
                  : {}
              }
            />
          )}
          <Grid2 rows={get(user, 'contacts', [])} columns={columns}>
            <Table />
            <TableHeaderRow />
          </Grid2>
        </div>
      </Paper>
      <Paper className={classes.paper}>
        <h2>Rezervace</h2>
        <Grid2 rows={items} columns={columnsReservation}>
          <DateTypeProvider for={['createdDate', 'from', 'to']} />
          <Table rowComponent={TableRow} />
          <TableHeaderRow />
        </Grid2>
      </Paper>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/users/detail.js